import { colors } from "material-ui";

const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 0,
    paddingBottom: 0,
    marginBottom: 25,
    paddingLeft: "0!important"
  }),
  removeMargin: {
    marginLeft: 0
  },
  jobsHeader: {
    backgroundColor: "#005795",
    padding: "15px!important",
    paddingBottom: "0!important",
    "& h2": {
      color: "white",
      fontSize: "1.5rem",
      fontWeight: 300,
      letterSpacing: "0.5px",
      marginBottom: "5px",
      display: "inline-block",
      //textOverflow: "ellipsis",
      position: "relative",
      maxWidth: "280px",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    "& h3": {
      color: "white",
      fontSize: "1rem",
      fontWeight: 300,
      //textOverflow: "ellipsis",
      position: "relative",
      maxWidth: "240px",
      whiteSpace: "nowrap",
      overflow: "auto"
    }
  },
  jobTotals: {
    paddingTop: 25,
    "& div": {
      padding: "0!important"
    }
  },
  jobDate: {
    display: "inline-block",
    float: "right"
  },
  jobCustomer: {
    maxWidth: "240px",
    overflowX: "scroll",
    marginRight: 10
  },
  innerjobDetails: {
    display: "flex",
    justifyContent: "space-between"
  },
  totalGrid: {
    borderRight: "1px solid grey",
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0
    }
  },
  passedGrid: {
    borderRight: "1px solid grey",
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0
    }
  },
  failedGrid: {
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0
    }
  },
  selectedGrid: {
    borderLeft: "1px solid #FF5252",
    "& p": {
      fontSize: "0.8rem",
      letterSpacing: "1.2px",
      marginBottom: -10
    },
    "& h1": {
      fontSize: "2.5rem",
      marginBottom: 0
    }
  },
  totalText: {
    color: "grey"
  },
  passedText: {
    color: "#4CAF50"
  },
  failedText: {
    color: "#FF5252"
  },
  selectedText: {
    color: "black"
  },
  jobCardRight: {
    position: "relative"
  },
  viewJob: {
    backgroundColor: theme.palette.accent,
    position: "absolute",
    bottom: 45,
    right: 15,
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  jobcardButtons: {
    padding: "0 15px",
    minWidth: "initial",
    "& span": {
      color: "white",
      fontSize: 15
    }
  },
  progressBar: {
    marginBottom: "15px"
  },
  jobFunctions: {
    background: "#1F2532",
    marginLeft: "-15px",
    marginRight: "-15px",
    marginTop: 15,
    bottom: "-10px",
    alignItems: "flex-end",
    borderTop: "grey 1px solid"
  },
  jobCardRight: {
    "& a": {
      width: "100%"
    }
  },
  syncButton: {
    display: "inline-block",
    marginLeft: "5%",
    "& span": {
      color: "white!important",
      fontSize: 12,
      fontWeight: 300
    }
  },
  toggle: {},
  toggleBar: {
    backgroundColor: "grey"
  },
  toggleOn: {
    "& + $toggleBar": {
      backgroundColor: "#36d036"
    }
  },
  jobHeaderDetails: {
    width: "100%"
  },
  attachmentExists: {
    backgroundColor: "#FF7043",
    marginTop: 1,
    "&:hover": {
      backgroundColor: "#FF7043"
    }
  },
  jobStatus: {
    fontSize: "0.8rem",
    color: "#1F2532",
    fontWeight: 700
  },
  reloadButton: {
    padding: 0,
    minWidth: "initial",
    width: "5%",
    marginLeft: 20,
    "& span": {
      color: "white",
      fontSize: 16
    },
    "&:hover": {
      backgroundColor: "#1F2532"
    },
    backgroundColor: "#1F2532",
    minHeight: "24px !important"
  },
  exportIcon: {
    display: "inline !important"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/jobs/styles.js